<ng-container *ngIf="!loading">
  <div class="container">

    <div class="container-right">
      <div class="stage-block-causes">
        <div [attr.class]="'causes-block current-weather'">
          <!-- [ngStyle]="{'height': getHeighInIOS() +'%', 'bottom':getBottomInIOS() + '%'}" -->
          <!-- <img [attr.src]="'/assets/svg-icons/weather'+'.svg'" class="item-media-play-btn"
            alt="causes.troubleFactorTitle"> -->
            <span style="font-size: large"><strong>t</strong></span>
            <ng-container *ngIf="buildingPorcess.set8?.temperature && buildingPorcess.set8?.temperature > 0; else elseTemperature">              
              <span>+{{ buildingPorcess.set8?.temperature }} <sup>o</sup>C</span>
            </ng-container>
            <ng-template #elseTemperature>
              <span>{{ buildingPorcess.set8?.temperature }} <sup>o</sup>C</span>
            </ng-template>
        </div>
        <ng-container *ngFor="let causes of buildingPorcess.troubleCount">
          <div [attr.class]="'causes-block '+getBuildingCausesType(causes)"
            (click)="causes.factorTypeID === 2 ? getWeatherList() : ''">              
            <!-- [ngStyle]="{'height': getHeighInIOS() +'%', 'bottom':getBottomInIOS() + '%'}" -->
            <img [attr.src]="'/assets/svg-icons/'+getBuildingCausesType(causes)+'.svg'" class="item-media-play-btn"
              alt="causes.troubleFactorTitle">
            <ng-container *ngIf="causes.factorTypeID === 2; else elseTemplate">
              <span>
                <span class="dayCount">{{causes.dayCount ? causes.dayCount : '-'}}</span>
                {{causes.forecastDayCount ? '('+causes.forecastDayCount+')' : ''}} дн
              </span>
            </ng-container>
            <ng-template #elseTemplate>
              <span>{{causes.dayCount ? causes.dayCount : '-'}} дн</span>
            </ng-template>
          </div>
        </ng-container>
      </div>

      <div class="weather-tooltip" id="idForScroll" *ngIf="weatherTooltipView">
        <table class="table-tooltip">
          <tbody>
            <tr class="tooltip-row">
              <td class="data-header">
                Дата
              </td>
              <td class="data-header">
                Фактор
              </td>
              <td class="data-header">
                Значение
              </td>
            </tr>

            <tr *ngFor="let item of buildingPorcess.weather" class="tooltip-row" [ngClass]="{'forecast': isForecastDate(item.weatherDate)}">
              <td class="data">
                {{ item.weatherDate | dateFormat }}
              </td>
              <td class="data">
                {{ item.troubleFactorTitle }}
              </td>
              <td class="data">
                {{ item.value + ' ' + item.unitTitle}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="graphic">
        <ng-container *ngIf="!noData">
          <app-line-chart [fullScreen]="false" [data]="buildingPorcess" [buildingID]="selectedBuildindId" [selectedStageNumber]="selectedStageNumber"></app-line-chart>
        </ng-container>
        <ng-container *ngIf="noData">
          <div class="no-content">нет данных</div>
        </ng-container>
      </div>

      <div class="stage-block">
        <div class="stage" (click)="selectStage('sum')" [ngClass]="{'active': selectedStageNumber === null}">
          <div class="percent" [ngStyle]="{'background-color':getColorByDeviationTypeId(totalPercent.deviationTypeID), 'color': getColorByDeviationTypeId(totalPercent.deviationTypeID) === 'yellow' ? '#000000' : '#FFFFFF'}">
            {{totalPercent.complete | numberWithSpaces: 'roundingFalse'}}{{totalPercent.complete > 0 ? '%' : ''}}
          </div>
          <div class="stage-title">&sum;</div>
        </div>
        <div class="stage" *ngFor="let stage of stages; let i = index" (click)="stage.complete > 0 ? selectStage(stage.number) : ''"
          [ngStyle]="{'cursor':stage.complete > 0 ? 'pointer' : 'default'}" [ngClass]="{'active':selectedStageNumber === stage.number}">
          <div class="tooltip">
            <div class="tooltip-title">{{getTooltip(stage.number)}}</div>
            <div class="tooltip-body">
              <div class="tooltip-body-left">
                <div class="left-percent">{{stage.complete | numberWithSpaces: 'roundingFalse'}}%</div>
                <div class="left-title">ГПР</div>
              </div>
              <div class="tooltip-body-right">
                <div class="first-date">{{stage.start_date === null ? '-' : (stage.start_date | dateFormat) }}</div>
                <div class="second-date">{{stage.end_date === null ? '-' : (stage.end_date | dateFormat) }}</div>
              </div>
            </div>
          </div>
          <div class="percent" [ngStyle]="{'background-color': 'green', 'color': '#FFFFFF'}">
            {{stage.complete | numberWithSpaces: 'roundingFalse'}}{{stage.complete > 0 ? '%' : ''}}
          </div>
          <div class="stage-title">{{stage.number}} этап</div>
        </div>
      </div>

    </div>
  </div>

</ng-container>

<ng-container *ngIf="loading">
  <div class="progress-content">
    <div class="progressbar"></div>
  </div>
</ng-container>
